import { useEffect, useState } from "react";
import { resolveIP } from "../services/geoService";

export default function useActiveListeners() {
  const [listeners, setListeners] = useState([]);

  useEffect(() => {
    const load = async () => {
      const res = await fetch("https://radioital.com/api/public/api/site/active");
      const ips = await res.json();

      const resolved = await Promise.all(
        ips.map(ip => resolveIP(ip))
      );

      setListeners(
        resolved
      );
    };

    load();
    const i = setInterval(load, 5000);
    return () => clearInterval(i);
  }, []);

  return listeners;
}